// extracted by mini-css-extract-plugin
module.exports = {"SimplexCheckOut":"SimplexCheckout_SimplexCheckOut__2S2Z0","SimplexCheckOutForm":"SimplexCheckout_SimplexCheckOutForm__3rdl1"};